// WidgetSection — Conteneur principal d'un widget de la page Résultats (et autres pages de reporting).
// Reproduit le style du conteneur de GenericCrudCard : fond blanc, coins arrondis, ombre, padding.
// Utiliser WidgetHeader à l'intérieur pour l'en-tête icône + titre.

// Import React
import React from 'react';

// Import clsx
import clsx from 'clsx';

// --- Interface ---

interface WidgetSectionProps {
	children: React.ReactNode;
	className?: string;
}

// --- Composant ---

const WidgetSection: React.FC<WidgetSectionProps> = ({
	children,
	className,
}) => (
	<div
		className={clsx(
			'max-w-6xl mx-auto bg-white rounded-lg shadow-md p-6',
			className
		)}
	>
		{children}
	</div>
);

export default WidgetSection;
